<template>
  <!-- Old bit.dev component -->
  <component class="c-base-button-bottom button" :is="tag">
    <!-- Use this slot to set text button -->
    <slot>Cadastrar ou criar minha conta</slot>
  </component>
</template>

<script>
export default {
  props: {
    // Use this to define of list type: ```<a>``` or ```<button> ```
    tag: {
      type: String,
      default: 'button',
      validator(value) {
        return ['a', 'button'].indexOf(value) >= 0
      },
    },
  },
}
</script>

<style lang="scss">
.c-base-button-bottom {
  margin: 0 auto;
  width: 100%;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  @media (max-width: $tablet) {
    @include position(absolute, auto, 0, 0, 0);
  }
  @media (min-width: $tablet) {
    width: initial;
    border-bottom-right-radius: $button-border-radius;
    border-bottom-left-radius: $button-border-radius;
  }
}
</style>
